const getVisibilityOptions = (isPublisher, isInternal) => {
    let options = ["internal","advertisers","all"];
    if(!isInternal && !isPublisher){
        options = ["advertisers","all"]
    }
    return options;
}

export default getVisibilityOptions;